import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { IClassCategory } from "../../../models/ClassEvent";
import { ClassEventService } from "../../../services/class-event.service";

export const useGetAllClassCategoriesQuery = () => {
  return useQuery<IClassCategory[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_CLASS_CATEGORIES],
    queryFn: () => ClassEventService.getAllClassCategories().then((res) => res.data),
  });
};
